import { type FC, memo, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './index.module.scss';
import closeIcon from '@assets/images/parrot/close.svg';

const Toast: FC = () => {
  useEffect(() => {
    return toast.onChange(({ status, id }) => {
      if (status === 'added' && !document.hasFocus()) {
        toast.dismiss(id);
      }
    });
  }, []);

  return (
    <div className={styles.toastContent}>
      <ToastContainer
        pauseOnFocusLoss={false}
        hideProgressBar
        theme="dark"
        className={styles.wrapper}
        toastClassName={styles.toast}
        autoClose={5000}
        closeButton={<img src={closeIcon} data-icon className={styles.close} />}
      />
    </div>
  );
};

export default memo(Toast);
